import { render, staticRenderFns } from "./DashboardKey.vue?vue&type=template&id=c9f9743e&scoped=true&"
import script from "./DashboardKey.vue?vue&type=script&lang=js&"
export * from "./DashboardKey.vue?vue&type=script&lang=js&"
import style0 from "./DashboardKey.vue?vue&type=style&index=0&id=c9f9743e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9f9743e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c9f9743e')) {
      api.createRecord('c9f9743e', component.options)
    } else {
      api.reload('c9f9743e', component.options)
    }
    module.hot.accept("./DashboardKey.vue?vue&type=template&id=c9f9743e&scoped=true&", function () {
      api.rerender('c9f9743e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/peach-pear-plum/components/peach/DashboardKey.vue"
export default component.exports